import { Box, Grid, Skeleton } from "@mui/material";

const ROW_COUNT = 20;

export const ContactViewLoader = () => {
  return (
    <Box sx={{ px: 1, mx: "auto" }}>
      <Grid
        container
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item xs={6} sm={8} md={6} lg="auto">
          <Skeleton
            variant="rectangular"
            sx={{
              borderRadius: 1,
              height: { xs: 24, md: 36 },
              width: { xs: "100%", lg: "430px" },
              mb: { xs: 0, md: 2 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg="auto">
          <Skeleton
            variant="rectangular"
            height={36}
            sx={{ borderRadius: 1, mb: 2, width: { xs: "100%", lg: "550px" } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Skeleton
            variant="rectangular"
            height={36}
            sx={{ borderRadius: 1, width: "100%" }}
          />
        </Grid>
      </Grid>

      <Grid container direction="column" spacing={2}>
        {Array.from({ length: ROW_COUNT - 1 }).map((_, i) => (
          <Grid item key={i}>
            <Skeleton
              variant="rectangular"
              height={28}
              width="100%"
              sx={{ borderRadius: 1 }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
